import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid2, Modal, styled, Typography } from "@mui/material";
import { useUpdateEffect } from "react-use";
import { useHermes } from "./useHermes";
import { WorkIcon } from "./WorkIcon";
const ModalContent = styled('div')(({ theme })=>({
        alignContent: 'center',
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
        width: '100vw'
    }));
const Description = styled(Typography)({
    color: 'black',
    maxWidth: 375
});
const Disclaimer = styled(Typography)({
    color: '#6B6B6B',
    maxWidth: 375
});
export const Overlay = (props)=>{
    const [overlay, state] = useHermes('overlay');
    useUpdateEffect(()=>{
        if (props.onOverlay) {
            props.onOverlay(!!overlay);
        }
    }, [
        overlay
    ]);
    useUpdateEffect(()=>{
        if (props.onConnected) {
            props.onConnected(state.connected);
        }
    }, [
        state.connected
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                "aria-describedby": [
                    overlay?.description ? 'overlay-description' : '',
                    overlay?.disclaimer ? 'overlay-disclaimer' : ''
                ].join(' '),
                "aria-labelledby": "overlay-title",
                "aria-modal": "true",
                open: !!overlay,
                children: /*#__PURE__*/ _jsx(ModalContent, {
                    children: /*#__PURE__*/ _jsxs(Grid2, {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ _jsx(Grid2, {
                                display: "flex",
                                justifyContent: "center",
                                size: {
                                    xs: 12
                                },
                                children: /*#__PURE__*/ _jsx(WorkIcon, {
                                    "aria-hidden": true,
                                    sx: {
                                        fill: 'none',
                                        height: 200,
                                        width: 200
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(Grid2, {
                                display: "flex",
                                justifyContent: "center",
                                size: {
                                    xs: 12
                                },
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    align: "center",
                                    color: "primary",
                                    id: "overlay-title",
                                    variant: "h1",
                                    children: overlay?.title
                                })
                            }),
                            overlay?.description && /*#__PURE__*/ _jsx(Grid2, {
                                display: "flex",
                                justifyContent: "center",
                                size: {
                                    xs: 12
                                },
                                children: /*#__PURE__*/ _jsx(Description, {
                                    align: "center",
                                    id: "overlay-description",
                                    paragraph: true,
                                    variant: "g1",
                                    children: overlay?.description
                                })
                            }),
                            overlay?.disclaimer && /*#__PURE__*/ _jsx(Grid2, {
                                display: "flex",
                                justifyContent: "center",
                                size: {
                                    xs: 12
                                },
                                children: /*#__PURE__*/ _jsx(Disclaimer, {
                                    align: "center",
                                    id: "overlay-disclaimer",
                                    paragraph: true,
                                    variant: "g1",
                                    children: overlay?.disclaimer
                                })
                            })
                        ]
                    })
                })
            }),
            !state.connected && props.ensureConnected !== false || overlay || props.children === undefined ? null : props.children
        ]
    });
};
Overlay.displayName = 'Overlay';

//# sourceMappingURL=Overlay.js.map